// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test'
    //suggestionPosition: 'left'
  }
};

(function() { // Add this
  BoostPFS.inject(this); // Add this

  /* some code */
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {};

  InstantSearch.prototype.beforeInit = function(id) {
    // Remove the default Instant Search of the theme
    jQ('.live-search-form, .site-header-search-form').removeAttr('data-live-search-form').removeAttr('data-live-search-flydown');
    jQ('input[name="q"]').removeAttr('data-live-search-input');
    jQ('.search-flydown').hide();
    jQ('button.site-header-search-button.button-primary').prop("type", "submit");
    jQ('button.live-search-button.button-primary').prop("type", "submit");
    jQ(document).ready(function() {
      jQ('.live-search-form, .site-header-search-form').off(".search-form");
      if (typeof bcHeaderSearch !== 'undefined') bcHeaderSearch.unload();
    });
  };

  Utils.buildProductItemUrl = (data, hasCollection) => {
    // Get url information
    var params = Utils.getWindowLocation().search.substring(1);
    var pathname = window.location.pathname;
    var elements = pathname.split('/');

    // Check if has locale
    var localeURLPart = "";
    var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
    if (Settings.getSettingValue('general.useShopifyRouteForMultiLanguageURL') && hasShopifyRoutes) {
      localeURLPart = Shopify.routes.root.replace(/\/$/, '');
    } else if (elements.indexOf(boostPFSAppConfig.general.current_locale) > -1) {
      localeURLPart = "/" + boostPFSAppConfig.general.current_locale;
    }

    // Get product handle
    var handle = typeof data === 'object' && data.hasOwnProperty('handle') ? data.handle : data;
    var hasCollection = typeof hasCollection !== 'undefined' ? hasCollection : Settings.getSettingValue('general.addCollectionToProductUrl');
    if (hasCollection) {
      // Homepage or Search page
      if (pathname == '/' || Utils.isSearchPage() || Utils.isVendorPage() || Utils.isTypePage()) {
        var preHandle = localeURLPart + '/collections/all/products/';
        return preHandle + handle;

        // Tag Page
      } else if (Utils.isTagPage()) {
        var preHandle = localeURLPart + '/collections/';
        var collectionHandleIndex = elements.indexOf("collections") + 1
        if (elements.length >= 4) return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
        return '/collections/all/products/' + handle;
      } else {
        // Google cache URL
        // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
        if (params.indexOf('cache:') > -1) {
          var collectionHandle = 'all';
          var temp = params.split('&')[0].split('?')[0].split('collections/');
          if (temp.length > 1) {
            if (temp[1].indexOf('/') > -1) {
              collectionHandle = temp[1].split('/')[0];
            } else {
              collectionHandle = temp[1];
            }
          }
          collectionHandle = collectionHandle.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, '');
          return '/collections/' + collectionHandle + '/products/' + handle;
        }
        var collectionHandleIndex = elements.indexOf("collections") + 1;
        var preHandle = localeURLPart + '/collections/';
        if (typeof elements[2] !== 'undefined') {
          // Build for collection pages
          if ((localeURLPart === '' && elements[1] === 'collections') || localeURLPart !== '') return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
          //Build for other pages, use collection/all
          return preHandle + 'all' + elements[collectionHandleIndex] + '/products/' + handle;
        }

        // Fix search in cart page
        if(window.location.pathname == '/cart'){
          return '/products/' + handle;
        }

        return window.location.pathname + '/products/' + handle;
      }
    }

    return localeURLPart + '/products/' + handle;
  };
 var originalSetData = InstantSearchResultItemProduct.prototype.setData;
InstantSearchResultItemProduct.prototype.setData = function(data) {
  if (data && data.variants && data.variants.length) {
    var validVariants = data.variants.filter(function(v) {
      return v.price > 0 && !(v.sku && v.sku.indexOf('SAMP-') === 0);
    });
    if (validVariants.length) {
      var lowestPrice = Math.min.apply(null, validVariants.map(function(v) { return v.price; }));
      data = JSON.parse(JSON.stringify(data)); // clone to avoid mutating original
      data.price_min = lowestPrice;
      // If not on sale after filtering, reset compare price
      if (data.compare_at_price_min <= lowestPrice) {
        data.compare_at_price_min = 0;
      }
    }
  }
  originalSetData.call(this, data);
};
})();

